// extracted by mini-css-extract-plugin
export default {"toolHeading":"ToolHeading_toolHeading__cK3t9"};